export const ASSETS = 'assets';
export const COMMANDS = 'commands';
export const CREATE_REMINDER = 'createReminder';
export const CREATE_RULE = 'createRule';
export const CREATE_WEATHER_RULE = 'createWeatherRule';
export const DETAILS = 'details';
export const EDIT_REMINDER = 'editReminder';
export const EDIT_RULE = 'editRule';
export const OUTPUT_SIGNALS = 'outputSignals';
export const RULES = 'rules';
export const SIGNALS = 'signals';
export const TRANSFORMS = 'transforms';
export const DM1 = 'dm1';
export const MAINTENANCE = 'maintenance';

export const ASSET_MODEL_TABS = [
  ASSETS,
  COMMANDS,
  CREATE_REMINDER,
  CREATE_RULE,
  CREATE_WEATHER_RULE,
  DETAILS,
  EDIT_REMINDER,
  EDIT_RULE,
  MAINTENANCE,
  OUTPUT_SIGNALS,
  RULES,
  SIGNALS,
  TRANSFORMS,
  DM1,
];
export const NAV_TABS = [
  SIGNALS,
  OUTPUT_SIGNALS,
  DETAILS,
  RULES,
  ASSETS,
  COMMANDS,
  TRANSFORMS,
  DM1,
  MAINTENANCE,
];
export const REMINDER_TABS = [CREATE_REMINDER, EDIT_REMINDER];
export const RULE_TABS = [CREATE_RULE, CREATE_WEATHER_RULE, EDIT_RULE];
